"use client";

// packages/eden-icons/src/generated-from-source/LoadingSpinner.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var LoadingSpinner = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10zM4.497 12a7.503 7.503 0 1015.006 0 7.503 7.503 0 00-15.006 0z", opacity: "0.2", children: " " }),
  /* @__PURE__ */ jsxs("path", { fill: color, d: "M2.422 14.874a10 10 0 006.258 6.559l.829-2.356a7.503 7.503 0 01-4.696-4.92l-2.391.717z", children: [
    " ",
    /* @__PURE__ */ jsx("animateTransform", { attributeName: "transform", type: "rotate", from: "0 12 12", to: "360 12 12", dur: "1.2s", repeatCount: "indefinite", children: " " })
  ] })
] });
var LoadingSpinner_default = LoadingSpinner;
export {
  LoadingSpinner_default as default
};
